export const DraggablePanelParts = {
  Panel: 'draggable-panel',
  Header: 'draggable-panel__header',
  Handle: 'draggable-panel__handle',
  Body: 'draggable-panel__body',
}
